import { Theme } from '@mui/material/styles'
import { Props } from './BillToSelect'

export const getStyles = (theme: Theme, props: Props) => ({
  resultsCountLabel: {
    margin: `${theme.spacing(1.2)} 0`,
  },
  searchBox: {
    marginTop: props.marginTop ? props.marginTop : theme.spacing(1.5),
    marginBottom: props.marginBottom ? props.marginBottom : theme.spacing(3),
  },
  sectionHeading: {
    fontFamily: 'Source Sans Pro',
    fontSize: '16px',
    lineHeight: '20px',
    color: theme.palette.text.primary,
  },
})

export const getSearchBarStyles = (theme: Theme) => ({
  searchIcon: {
    color: '#cbcbcb',
  },

  searchTextField: {
    '&::focus': {
      backgroundColor: theme.palette.common.white,
    },
  },

  searchTextFieldInput: {
    backgroundColor: theme.palette.common.white,
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '14px',
    color: '#848282',
  },

  searchAdornment: {
    cursor: 'pointer',
  },
})
